__turbopack_context__.v({
  "root": "tabItem-module-scss-module__MlU_qW__root",
});
